import script from "./ServiceForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceForm.vue?vue&type=script&setup=true&lang=js"

import "./ServiceForm.vue?vue&type=style&index=0&id=24e3bd88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24e3bd88"]])

export default __exports__